import React from 'react';
import { Link } from 'react-router-dom';
import { ReportYear } from '~/components/Nav/ReportYear';
import { AuthContext, AuthContextType } from '~/services/AuthContext';
import { ReminderContext, ServicesContext, initialReminderFilters } from '~/services';
import { TimelyActionCounter } from '~/components/Reminders';
import { mapValueArray } from '~/util';
import { ReminderContextType } from '~/services/ReminderContext';
import { Dropdown } from './Dropdown';

export function Nav() {
    const { authenticated } = React.useContext(AuthContext) as AuthContextType;
    const { setFilterValues, resetSort, clinicList, pcpList } = React.useContext(
        ReminderContext
    ) as ReminderContextType;
    const context = React.useContext(ServicesContext);

    return (
        <nav className="navbar navbar-expand navbar-dark shadow-sm">
            <div className="container-fluid">
                <Link to={authenticated ? '/dashboard' : '/'} className="navbar-brand">
                    <span aria-label="Leading Reach Zephyr" role="heading" aria-level={1} />
                    <img src="/lr-zephyr-reverse.png" alt="Leading Reach Zephyr" />
                </Link>
                {authenticated && <ReportYear />}
                {authenticated && (
                    <>
                        <span className="navbar-nav ms-auto">
                            <Link
                                to="/reminders"
                                className="nav-link position-relative"
                                title="Timely Actions"
                                onClick={() => {
                                    const notificationFilters =
                                        context.user.getSavedSearchData().savedNotificationOptions
                                            ?.filters;
                                    resetSort();
                                    setFilterValues({
                                        ...initialReminderFilters,
                                        createdByType: 'system',
                                        viewStatus: ['open'],
                                        clinic:
                                            notificationFilters?.clinic && clinicList
                                                ? mapValueArray(
                                                      notificationFilters?.clinic,
                                                      clinicList
                                                  )
                                                : [],
                                        PCP:
                                            notificationFilters?.pcp && pcpList
                                                ? mapValueArray(notificationFilters?.pcp, pcpList)
                                                : [],
                                    });
                                }}
                            >
                                <i className="fa-regular fa-clock" />
                                <TimelyActionCounter />
                            </Link>
                            <Link
                                to="/reminders"
                                className="nav-link"
                                title="Reminders"
                                onClick={() => {
                                    resetSort();
                                    setFilterValues({
                                        ...initialReminderFilters,
                                        createdByType: 'user',
                                        viewStatus: ['open'],
                                    });
                                }}
                            >
                                <i className="fa-solid fa-bell" />
                            </Link>
                        </span>
                        <ul className="navbar-nav">
                            <Dropdown />
                        </ul>
                    </>
                )}
            </div>
        </nav>
    );
}
